import type { zhHK } from '../zh-HK';

/**
 * en —— 英文（**必須同 zh-HK 逐 key 對齊**；型別由 `typeof zhHK` 檢查）
 */
export const en: typeof zhHK = {


  language_label: 'Language',
  locale_zh_hk: '繁體中文（香港）',
  locale_en: 'English',
  locale_zh_cn: '简体中文',

  back_home: 'Back to home',

  login_email: 'Email',
  login_password: 'Password',
  login_submit: 'Sign in',
  login_working: 'Signing in…',
  login_failed: 'Sign-in failed, please try again.',
  login_phone_ph: 'Enter your mobile number',

  setpw_title: 'Set password',
  setpw_new: 'New password (min 8 characters)',
  setpw_confirm: 'Confirm password',
  setpw_submit: 'Set & sign in',
  setpw_working: 'Setting…',
  setpw_mismatch: 'Passwords do not match',
  setpw_nolink: 'Invite link is incomplete (no token) — please use the full link from the admin.',
  setpw_failed: 'Failed, please try again.',

  member_title: 'Members',
  member_greeting: 'Hello, {{email}}',
  member_role: 'Role: {{role}}',
  member_todo: 'Member features (membership / events / documents / notifications) will be added from M3 onward.',
  logout: 'Sign out',

  'tab.aria': 'Bottom navigation',
  'tab.benefits': 'Benefits',
  'tab.news': 'News',
  'tab.cards': 'My Cards',
  'tab.ads': 'Ads',
  'tab.settings': 'Settings',
  page_todo: 'This section will be implemented after M3 (not built yet).',

  admin_title: 'Admin',
  admin_members: 'Members',
  admin_benefits: 'Benefits',
  admin_news: 'News',
  admin_back: 'Back to members area',
  btn_new: 'New',
  btn_edit: 'Edit',
  btn_delete: 'Delete',
  btn_save: 'Save',
  btn_cancel: 'Cancel',
  confirm_delete: 'Delete this item?',
  empty_none: 'No data yet',
  col_no: 'Member no.',
  col_name: 'Name',
  col_type: 'Type',
  col_status: 'Status',
  col_email: 'Email',
  col_phone: 'Phone',
  col_company: 'Company',
  col_title: 'Title',
  col_partner: 'Partner',
  col_published: 'Status',
  f_title: 'Title',
  f_body: 'Body',
  f_partner: 'Partner',
  f_valid_from: 'Valid from',
  f_valid_to: 'Valid to',
  f_name: 'Name',
  f_type: 'Membership type',
  f_company: 'Company',
  f_email: 'Email',
  f_phone: 'Phone',
  f_status: 'Status',
  f_notes: 'Notes',
  f_photo: 'Member photo',
  f_photo_remove: 'Remove photo',
  photo_title: 'My photo',
  photo_uploading: 'Uploading…',
  photo_saved: 'Photo updated',
  photo_err_big: 'Photo is too large — please choose another',
  photo_err_config: 'Photo service is not configured — please contact the administrator',
  photo_err_generic: 'Upload failed — please try again',
  f_published: 'Published',
  status_active: 'Active',
  status_pending: 'Pending',
  status_expired: 'Expired',
  status_disabled: 'Disabled',
  published_yes: 'Published',
  published_no: 'Draft',
  card_member_no: 'Member no.',
  card_expires: 'Valid until',
  card_no_link: 'Your account is not linked to a member record (please contact the admin).',
  join_open_wa: 'Register with WhatsApp',
  join_name_ph: 'Name',
  join_company_ph: 'Company',
  join_submit: 'Send via WhatsApp',
  join_name_required: 'Please enter your name',
  join_wa_unavailable: 'WhatsApp registration is temporarily unavailable',
  join_wa_prefill: 'Register\nName: {{name}}\nCompany: {{company}}',
  token_working: 'Signing in…',
  token_invalid: 'This link is invalid or has expired. Please register again.',
  legal_updated: 'Last updated: 2026-10-05',
  privacy_title: 'Privacy Policy',
  privacy_intro: 'This is how the Hong Kong Smart Catering Association (HKSCA) membership system (hksca.pages.dev) collects and uses your personal data. Using this system or registering via WhatsApp means you agree to this policy.',
  privacy_collect_h: 'What we collect',
  privacy_collect: 'Your name / company name, phone (WhatsApp) number, email, membership type and expiry, and other details you provide at registration.',
  privacy_use_h: 'How we use it',
  privacy_use: 'Only to administer membership, issue and display membership cards, send membership and event notifications, and contact you.',
  privacy_share_h: 'Sharing',
  privacy_share: 'We never sell or rent your data. It is only processed by service providers (e.g. cloud hosting, WhatsApp message delivery) where necessary, under contract.',
  privacy_retention_h: 'Retention',
  privacy_retention: 'Kept until a reasonable period after your membership ends, or until you ask us to delete it (except records we must keep by law).',
  privacy_rights_h: 'Your rights',
  privacy_rights: 'You may request access to, correction of, or deletion of your personal data. See "Data deletion instructions".',
  privacy_contact_h: 'Contact us',
  privacy_contact: 'Email simon@coeldery85.org to ask or make a request.',
  deletion_title: 'Data Deletion Instructions',
  deletion_intro: 'You may ask us to delete your personal data from the HKSCA membership system at any time.',
  deletion_how_h: 'How to request',
  deletion_step_1: 'Message or email us from the WhatsApp number or email you registered with.',
  deletion_step_2: 'State "request deletion of member data" and give your member number or registered phone.',
  deletion_step_3: 'We confirm and delete within 30 days, then reply to you.',
  deletion_scope_h: 'What is deleted',
  deletion_scope: 'Member record, memberships, membership card and login account — except transaction records we must keep by law.',
  deletion_contact: 'WhatsApp / email: simon@coeldery85.org (or message the association number from your registered WhatsApp).',
  terms_title: 'Terms of Service',
  terms_intro: 'These terms govern your use of the Hong Kong Smart Catering Association (HKSCA) membership system (hksca.pages.dev). By using it or registering via WhatsApp you accept these terms.',
  terms_accept_h: 'Acceptance',
  terms_accept: 'By using this system or completing registration you agree to these terms and related policies (including the Privacy Policy). If you do not agree, please stop using it.',
  terms_account_h: 'Membership & accounts',
  terms_account: 'Membership is granted at the association’s discretion. You must provide true and accurate information and keep your login credentials secure. You are responsible for activity under your account.',
  terms_conduct_h: 'Acceptable use',
  terms_conduct: 'Do not misuse the system, including but not limited to unauthorised access, disrupting the service, uploading unlawful or infringing content, impersonation or fraud.',
  terms_content_h: 'Content & IP',
  terms_content: 'Trademarks, logos and content in the system belong to the association or its partners. Offers and news are provided by partners; actual availability is subject to each merchant’s terms.',
  terms_liability_h: 'Limitation of liability',
  terms_liability: 'The system is provided “as is”; we strive for accuracy but do not warrant it is error-free. To the extent permitted by law we are not liable for losses arising from use of, or inability to use, the system.',
  terms_changes_h: 'Changes',
  terms_changes: 'We may update these terms from time to time; the updated version will be posted on this page with a new “Last updated” date. Continued use means you accept the new version.',
  terms_contact_h: 'Contact us',
  terms_contact: 'If you have questions about these terms, email simon@coeldery85.org.',
  pw_title: 'Change password',
  pw_none_hint: 'You have no password yet. Set one to log in next time with phone number + password (no WhatsApp needed).',
  pw_current: 'Current password',
  pw_save: 'Save password',
  pw_saved: 'Password updated ✅',
  pw_failed: 'Update failed, please try again.',
  ann_all: 'All committees',
  ann_unread: 'Unread',
  ann_empty: 'No announcements yet',
  task_new: 'New to-do',
  task_field_title: 'To-do',
  task_field_notes: 'Notes',
  task_field_owner: 'Owner',
  task_field_due: 'Due date',
  task_field_priority: 'Priority',
  task_field_committee: 'Committee',
  task_priority_1: 'High',
  task_priority_2: 'Medium',
  task_priority_3: 'Low',
  task_status_todo: 'To do',
  task_status_doing: 'In progress',
  task_status_done: 'Done',
  task_status_cancelled: 'Cancelled',
  task_unassigned: 'Unassigned',
  task_overdue: 'Overdue',
  task_empty: 'No to-dos yet',
  task_mine: 'Assigned to me',
  task_filter_all: 'All',
  task_scope_all: 'All committees',
  task_summary: '{{total}} items · {{done}} done',
  task_need_title: 'Please enter the to-do.',
  task_need_committee: 'Please choose a committee.',
  task_failed: 'Action failed, please try again.',
  mtg_new: 'Schedule a meeting',
  mtg_field_title: 'Meeting title',
  mtg_field_location: 'Location',
  mtg_field_starts: 'Starts at',
  mtg_field_ends: 'Ends at',
  mtg_field_committee: 'Committee',
  mtg_field_minutes: 'Minutes',
  mtg_status_scheduled: 'Scheduled',
  mtg_status_done: 'Completed',
  mtg_status_cancelled: 'Cancelled',
  mtg_empty: 'No meetings yet',
  mtg_scope_all: 'All committees',
  mtg_filter_all: 'All',
  mtg_count: '{{n}} agenda items',
  mtg_back: 'Back to meetings',
  mtg_agenda: 'Agenda',
  mtg_agenda_add: 'Add agenda item',
  mtg_agenda_title: 'Agenda item',
  mtg_agenda_notes: 'Notes',
  mtg_agenda_decision: 'Decision',
  mtg_agenda_empty: 'No agenda yet',
  mtg_action_from_agenda: 'Create to-do',
  mtg_attendance: 'Attendance',
  mtg_attendance_seed: 'Load committee roster',
  mtg_attendance_rate: 'Present {{present}}/{{roster}} ({{rate}}%)',
  mtg_attendance_empty: 'Attendance not loaded yet',
  mtg_att_invited: 'No reply',
  mtg_att_present: 'Present',
  mtg_att_absent: 'Absent',
  mtg_att_excused: 'Excused',
  mtg_actions: 'Action items',
  mtg_actions_hint: 'Action items are written to To-do immediately and linked back to this meeting.',
  mtg_action_add: 'Add action item',
  mtg_action_empty: 'No action items yet',
  mtg_minutes_save: 'Save minutes',
  mtg_saved: 'Saved ✅',
  mtg_failed: 'Action failed, please try again.',
  mtg_need_title: 'Please enter the meeting title.',
  mtg_need_time: 'Please choose the meeting time.',
  ctab_discussions: 'Discussion',
  disc_new: 'New topic',
  disc_field_title: 'Topic title',
  disc_field_body: 'Topic description',
  disc_open: 'Open',
  disc_closed: 'Closed',
  disc_empty: 'No topics yet',
  disc_scope_all: 'All committees',
  disc_filter_all: 'All',
  disc_posts: '{{n}} comments',
  disc_last: 'Last activity',
  disc_back: 'Back to discussions',
  disc_post_ph: 'Write a comment…',
  disc_post_send: 'Comment',
  disc_post_empty: 'No comments yet — start the discussion.',
  disc_close: 'Close topic',
  disc_reopen: 'Reopen',
  disc_closed_hint: 'This topic is closed and no longer accepts comments.',
  disc_delete_topic: 'Delete this topic',
  disc_need_title: 'Please enter the topic title.',
  disc_failed: 'Action failed, please try again.',
  polls: 'Votes',
  poll_new: 'New motion',
  poll_field_title: 'Motion title',
  poll_field_body: 'Motion description',
  poll_field_closes: 'Closes at',
  poll_status_open: 'Voting',
  poll_status_closed: 'Closed',
  poll_empty: 'No motions yet',
  poll_scope_all: 'All committees',
  poll_filter_all: 'All',
  poll_cast: '{{n}} voted',
  poll_my: 'You voted: {{option}}',
  poll_not_voted: 'You have not voted',
  poll_back: 'Back to votes',
  poll_closed_hint: 'This motion is closed and no longer accepts votes.',
  poll_closes_at: 'Closes',
  poll_voters: 'Vote record',
  poll_no_voters: 'No votes yet',
  poll_need_title: 'Please enter the motion title.',
  poll_failed: 'Action failed, please try again.',
  poll_close: 'Close voting',
  poll_reopen: 'Reopen',
  poll_delete: 'Delete this motion',
  poll_tied: '(tied)',
  opt_agree: 'Agree',
  opt_disagree: 'Disagree',
  opt_abstain: 'Abstain',
  rsvp_title: 'Invitation reply',
  rsvp_greeting: 'Dear {{name}}',
  rsvp_event: 'Event',
  rsvp_date: 'Date',
  rsvp_venue: 'Venue',
  rsvp_guests: 'Guests',
  rsvp_accept: 'I will attend',
  rsvp_decline: 'I cannot attend',
  rsvp_sent_accept: 'Recorded: you will attend. Thank you.',
  rsvp_sent_decline: 'Recorded: you cannot attend. Thank you.',
  rsvp_accepted: 'Accepted',
  rsvp_declined: 'Declined',
  rsvp_invalid: 'This link is invalid or has expired. Please contact the association secretariat.',
  rsvp_failed: 'Action failed, please try again.',
  ltr_title: 'Event letters',
  ltr_intro: 'Create templates, import recipient lists, send invitations in batches, and track replies (each recipient gets a personal RSVP link).',
  ltr_tab_templates: 'Templates',
  ltr_tab_groups: 'Lists',
  ltr_tab_sends: 'Send batches',
  ltr_purpose_invite: 'Invitation',
  ltr_purpose_sponsor: 'Sponsorship',
  ltr_purpose_thanks: 'Thank-you',
  ltr_purpose_other: 'Other',
  ltr_tpl_name: 'Template name',
  ltr_ai_brief: '(optional) extra instructions, e.g. emphasise GBA exchange',
  ltr_ai_draft: 'AI draft',
  ltr_ai_working: 'Generating…',
  ltr_ai_local: 'Draft generated (Workers AI — data never left Cloudflare). Please review before saving.',
  ltr_ai_third_party: '⚠️ Draft generated via a third-party AI. Please review before saving.',
  ltr_tpl_subject: 'Subject',
  ltr_tpl_body: 'Body',
  ltr_tpl_fields: 'Available merge fields: {{fields}}',
  ltr_tpl_new: 'Add template',
  ltr_saved: 'Saved ✅',
  ltr_failed: 'Action failed, please try again.',
  ltr_grp_count: '{{n}} recipients',
  ltr_grp_name: 'List name',
  ltr_grp_text: 'Paste recipients (one per line: email, name, company, title, phone)',
  ltr_grp_new: 'Add list',
  ltr_grp_parsed: 'Added {{n}} ({{skipped}} lines skipped)',
  ltr_status_draft: 'Draft',
  ltr_status_sending: 'Sending',
  ltr_status_done: 'Completed',
  ltr_status_cancelled: 'Cancelled',
  ltr_status_pending: 'Pending',
  ltr_status_sent: 'Sent',
  ltr_status_failed: 'Failed',
  ltr_status_simulated: 'Simulated',
  ltr_send_pick_tpl: 'Pick a template…',
  ltr_send_pick_grp: 'Pick a list…',
  ltr_send_new: 'Create send batch',
  ltr_need_pick: 'Please choose a template and a list first.',
  ltr_send_missing: 'Note: the template uses {{fields}} but recipients did not provide them — please fill the data or adjust the template.',
  ltr_send_created: 'Created {{n}} letters (personalised per recipient — preview = what is sent)',
  ltr_send_result: 'Processed {{n}} in this batch, {{remaining}} remaining.',
  ltr_rsvp_note: 'Every letter carries that recipient’s personal RSVP link; replies appear in the stats above immediately.',
  ltr_back: 'Back to letters',
  ltr_stat_pending: 'Pending',
  ltr_stat_sent: 'Sent',
  ltr_stat_simulated: 'Simulated',
  ltr_stat_failed: 'Failed',
  ltr_stat_accepted: 'Accepted',
  ltr_stat_declined: 'Declined',
  ltr_email_unconfigured: 'Email credentials not configured (EMAIL_API_KEY / EMAIL_FROM) — only simulated sending is available.',
  ltr_send_now: 'Send ({{n}} per batch)',
  ltr_send_dry: 'Simulate (no real email)',
  ltr_export: 'Export CSV',
  ltr_rotate: 'Regenerate RSVP link',
  ltr_rotate_note: 'Link regenerated (the old one is now invalid). If not yet sent, paste the new link where needed.',
  ltr_copy: 'Copy',
  ltr_copied: 'Copied',
  ltr_recipients: 'Recipients',
  ltr_tab_events: 'Events',
  ltr_evt_name: 'Event name',
  ltr_evt_venue: 'Venue',
  ltr_evt_new: 'Add event',
  ltr_evt_note: 'Event data feeds the {{event_name}} / {{event_date}} / {{event_venue}} merge fields.',
  ltr_evt_closed: 'Closed',
  ltr_send_pick_evt: '(optional) link an event…',
  admin_letters: 'Event letters',
  admin_sponsors: 'Sponsors',
  sp_intro: 'Manage sponsorship tiers (AI can draft them), track pipeline progress and amounts, and complete each sponsor’s benefit checklist.',
  sp_pipeline: 'Pipeline overview',
  sp_total_pledged: 'Total pledged',
  sp_total_paid: 'Total paid',
  sp_outstanding: 'Outstanding',
  sp_stage_lead: 'Lead',
  sp_stage_contacted: 'Contacted',
  sp_stage_pitched: 'Pitched',
  sp_stage_pledged: 'Pledged',
  sp_stage_confirmed: 'Confirmed',
  sp_stage_paid: 'Paid',
  sp_stage_declined: 'Declined',
  sp_tiers: 'Tiers',
  sp_tier_new: 'Add tier',
  sp_tier_code: 'Code (optional, e.g. diamond)',
  sp_name_hk: 'Name (TC)',
  sp_name_cn: 'Name (SC)',
  sp_name_en: 'Name (EN)',
  sp_tier_amount: 'Suggested amount (HKD)',
  sp_tier_benefits: 'Benefits (one per line)',
  sp_benefit_n: '{{n}} benefits',
  sp_benefit_unit: 'benefits',
  sp_ai_tiers: 'AI draft tiers',
  sp_ai_review: 'AI draft — please review before saving',
  sp_ai_save_all: 'Save all',
  sp_ai_working: 'Generating…',
  sp_ai_local: 'Draft generated (Workers AI — data never left Cloudflare). Please review.',
  sp_ai_third_party: '⚠️ Draft generated via a third-party AI. Please review.',
  sp_ai_saved: 'Saved {{n}} tiers',
  sp_sponsors: 'Sponsors',
  sp_sponsor_new: 'Add sponsor',
  sp_company: 'Company',
  sp_contact_name: 'Contact',
  sp_contact_email: 'Contact email',
  sp_contact_phone: 'Contact phone',
  sp_tier: 'Tier',
  sp_pledge: 'Pledged amount',
  sp_paid: 'Paid amount',
  sp_stage: 'Stage',
  sp_amounts: 'Amounts & follow-up',
  sp_owner_code: 'Owner code (no real names)',
  sp_next_action: 'Next action',
  sp_note: 'Notes',
  sp_benefits: 'Benefits delivery',
  sp_benefits_hint: 'Generate them from the tier in one click, then tick items off.',
  sp_seed: 'Generate from tier ({{n}})',
  sp_seeded: 'Generated {{n}} benefits',
  sp_add_benefit: 'Add benefit item',
  sp_back: 'Back to sponsors',
  sp_delete: 'Delete this sponsor',
  sp_failed: 'Action failed, please try again.',
  sp_saved: 'Saved ✅',
  sp_need_tier: 'Please fill in all three language names.',
  sp_need_company: 'Please enter the company name.',
  sp_ai_suggest: 'AI suggests next step',
  sp_ai_suggesting: 'Analysing…',
  sp_ai_apply: 'Apply suggestion',
  sp_suggest: 'AI suggests: {{stage}}',
  sp_suggest_reason: 'Reason: {{reason}}',
  admin_seating: 'Seating',
  admin_checkin: 'Check-in',
  seat_intro: 'Manage tables and guests, auto-seat in one click (preview first), and confirm arrivals on the Check-in page on the day.',
  seat_assign: 'Auto-seating',
  seat_preview_btn: 'Preview (no changes)',
  seat_commit_btn: 'Confirm seating',
  seat_clear: 'Clear seating',
  seat_rule_note: 'Rules: VIP first and prefer the VIP zone → larger parties first → never over capacity; anyone who cannot fit is listed by name, never dropped silently. Every assignment records a reason.',
  seat_result: 'Seated {{assigned}}, unseated {{unassigned}}',
  seat_occupancy: '{{seats}}/{{cap}} seated',
  seat_free: '{{n}} free',
  seat_totals: 'Totals: seated {{seats}} / capacity {{cap}} / unseated {{un}}',
  seat_tables: 'Tables',
  seat_capacity_n: 'capacity {{n}}',
  seat_table_label: 'Table label (e.g. Table 1)',
  seat_capacity: 'Capacity',
  seat_zone_vip: 'VIP zone',
  seat_zone_main: 'Main',
  seat_zone_other: 'Other',
  seat_table_new: 'Add table',
  seat_guests: 'Guests',
  seat_checked: '{{n}} checked in',
  seat_party_n: '{{n}} pax',
  seat_no_table: '(unseated)',
  seat_party: 'Party size',
  seat_guest_new: 'Add guest',
  seat_paste: 'Paste guests (one per line: name, company, contact, party size, VIP)',
  seat_import: 'Import',
  seat_parsed: 'Imported {{n}} ({{skipped}} lines skipped)',
  seat_committed: 'Seating confirmed ({{n}})',
  seat_preview: 'The above is a preview — click "Confirm seating" to save.',
  seat_saved: 'Saved ✅',
  seat_failed: 'Action failed, please try again.',
  ci_intro: 'Type or scan a guest’s check-in code (QR or manual; case-insensitive) to see their name and table.',
  ci_placeholder: 'Check-in code (e.g. G1A2B3C4)',
  ci_submit: 'Check in',
  ci_notfound: 'Code not found — please check, or pick from the list below.',
  ci_failed: 'Action failed, please try again.',
  ci_done_at: 'Checked in at {{at}}',
  ci_checked: '{{n}}/{{total}} checked in',
  ci_pending: 'Not yet arrived',
  ci_check: 'Check in',
  admin_budget: 'Reconciliation',
  bg_intro: 'Budget vs actual spend, plus sponsorship received — showing surplus or deficit at a glance.',
  bg_summary: 'Reconciliation summary',
  bg_items: 'Budget items',
  bg_category: 'Category',
  bg_budget: 'Budget',
  bg_actual: 'Actual',
  bg_variance: 'Variance',
  bg_expense: 'Expense',
  bg_income: 'Income',
  bg_other: 'Other',
  bg_cat_expense: 'Expense',
  bg_cat_income: 'Income',
  bg_cat_other: 'Other',
  bg_sponsor_paid: 'Sponsorship received (counted automatically)',
  bg_net_budget: 'Net (budget)',
  bg_net_actual: 'Net (actual)',
  bg_surplus: 'surplus',
  bg_deficit: 'deficit',
  bg_item: 'Item (e.g. venue hire)',
  bg_new: 'Add item',
  bg_saved: 'Saved ✅',
  bg_failed: 'Action failed, please try again.',
  bg_hint: 'Variance = actual − budget (positive means overspent). Sponsorship received is counted automatically — no manual entry.',
  admin_report: 'Event report',
  rp_ai: 'AI summary',
  rp_print: 'Print / save as PDF',
  rp_no_event: '(no event selected)',
  rp_no_date: 'date TBC',
  rp_ai_narrative: 'AI summary',
  rp_scale: 'Scale & attendance',
  rp_guests: '{{n}} guests ({{seats}} seats)',
  rp_checked: '{{n}} checked in',
  rp_unassigned: '{{n}} unseated',
  rp_tables: '{{n}} tables: {{seats}}/{{cap}} seats used',
  rp_sponsors: 'Sponsorship results',
  rp_sponsor_totals: '{{n}} companies: pledged {{pledged}} / paid {{paid}} / outstanding {{outstanding}}',
  rp_failed: 'Failed to load, please try again.',
  sp_thank_letter: 'Prepare thank-you letter',
  sp_thank_ok: 'Added to the "Thank-you list" — pick a thank-you template in Event letters to send.',
  committee_title: 'Committee',
  ctab_home: 'Home',
  ctab_announcements: 'Notices',
  ctab_meetings: 'Meetings',
  ctab_tasks: 'To-do',
  committee_need_login: 'Please sign in first (use your member phone number).',
  committee_my: 'My committees',
  committee_none: 'You are not in any committee yet — please contact the association.',
  committee_invitations: 'Pending invitations',
  committee_accept: 'Accept',
  committee_decline: 'Decline',
  committee_joined: 'Joined ✅',
  committee_declined: 'Declined',
  committee_soon_h: 'Coming soon',
  committee_soon_b: 'This feature is being added during Phase 2 (notices / meetings / to-do).',
  admin_committees: 'Committees',
  committee_new: 'New committee',
  committee_kind: 'Type',
  kind_board: 'Council',
  kind_functional: 'Functional committee',
  kind_working: 'Working committee / group',
  committee_code: 'Code',
  committee_name_hk: 'Name (TC)',
  committee_name_cn: 'Name (SC)',
  committee_name_en: 'Name (EN)',
  committee_sort: 'Order',
  committee_count: 'Members',
  committee_members: 'Members',
  committee_pick_member: 'Pick a member…',
  committee_invite: 'Invite',
  committee_status_active: 'Current',
  committee_status_invited: 'Pending reply',
  committee_invited_ok: 'Invitation sent',
  invite_member: 'Invite',
  invite_working: 'Generating…',
  invite_need_email: "Add the member's email first, then you can send an invite.",
  invite_failed: 'Invite failed, please try again.',
  invite_link_title: 'Invitation link (valid 7 days)',
  invite_copy: 'Copy link',
  invite_copied: 'Copied',
  invite_link_note: 'Send only to this member; they set a password to activate the account.',
  invite_bound: 'Account linked',
  footer_privacy: 'Privacy Policy',
  footer_deletion: 'Data Deletion',
  footer_terms: 'Terms of Service',
};
